export const RegimenFiscalArray=[
    {id:601,display:'General de Ley Personas Morales'},
    {id:603,display:'Personas Morales con Fines no Lucrativos'},
    {id:605,display:'Sueldos y Salarios e Ingresos Asimilados a Salarios'},
    {id:606,display:'Arrendamiento'},
    {id:607,display:'Regimen de Enajenacion o Adquisicion de Bienes'},
    {id:608,display:'Demas ingresos'},
    {id:609,display:'Consolidacion'},
    {id:610,display:'Residentes en el Extranjero sin Establecimiento Permanente en Mexico'},
    {id:611,display:'Ingresos por Dividendos (socios y accionistas)'},
    {id:612,display:'Personas Físicas con Actividades Empresariales y Profesionales'},
    {id:614,display:'Ingresos por intereses'},
    {id:615,display:'Regimen de los ingresos por obtención de premios'},
    {id:616,display:'Sin obligaciones fiscales'},
    {id:620,display:'Sociedades Cooperativas de Producción que optan por diferir sus ingresos'},
    {id:621,display:'Incorporación Fiscal'},
    {id:622,display:'Actividades Agricolas, Ganaderas, Silvicolas y Pesqueras'},
    {id:623,display:'Opcional para Grupos de Sociedades'},
    {id:624,display:'Coordinados'},
    {id:625,display:'Regimen de las Actividades Empresariales con ingresos a traves de Plataformas Tecnologicas'},
    {id:626,display:'Regimen Simplificado de Confianza'},
    {id:628,display:'Hidrocarburos'},
    {id:629,display:'De los Regimenes Fiscales Preferentes y de las Empresas Multinacionales'},
    {id:630,display:'Enajenación de acciones en bolsa de valores'},
]

const RegimenFiscalArrayMayusculas = RegimenFiscalArray.map(item => {
    return {
        id: item.id,
        display: item.display.toUpperCase()
    };
});

export { RegimenFiscalArrayMayusculas };